module.exports = __webpack_public_path__ + "static/media/resend-otp-new.397a4264.svg";